import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#111C26] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="https://static.readdy.ai/image/cf33c51050e95588e8f90f230098c778/2e85fd3c1c61935d17af19cdb38ff5c1.jpeg"
              alt="Aligned Home Care"
              className="w-12 h-12 object-contain rounded-full bg-white p-1"
            />
            <div className="flex flex-col leading-tight">
              <span className="text-base font-bold">Aligned</span>
              <span className="text-[10px] font-semibold tracking-[0.18em] uppercase text-[#D4A574]">Home Care</span>
            </div>
          </div>
          <div className="flex flex-col gap-2 text-sm text-white/55">
            <span className="flex items-center gap-2"><i className="ri-map-pin-line text-[#C0706A]"></i> Scotland, UK</span>
            <span className="flex items-center gap-2"><i className="ri-phone-line text-[#C0706A]"></i> 0131 2100021</span>
            <span className="flex items-center gap-2"><i className="ri-mail-line text-[#C0706A]"></i> info@alignedhomecare.uk</span>
          </div>
        </div>

        <div>
          <h4 className="font-semibold text-sm uppercase tracking-widest mb-5 text-[#D4A574]">Quick Links</h4>
          <ul className="flex flex-col gap-3 text-sm text-white/55">
            {[
              { label: 'Our Services', id: 'services' },
              { label: 'How It Works', id: 'how-it-works' },
              { label: 'About Us', id: 'about' },
              { label: 'Contact', id: 'contact' },
            ].map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => scrollTo(l.id)}
                  className="hover:text-[#D4A574] transition-colors cursor-pointer whitespace-nowrap"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <Link to="/policy" className="hover:text-[#D4A574] transition-colors cursor-pointer whitespace-nowrap">
                Policies &amp; Procedures
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-sm uppercase tracking-widest mb-5 text-[#D4A574]">Our Services</h4>
          <ul className="flex flex-col gap-3 text-sm text-white/55">
            {['Daily Health Support', 'Personal Care', 'Memory Care', 'Companionship', 'Household Support', 'Respite Care'].map((s) => (
              <li key={s}>
                <button
                  onClick={() => scrollTo('services')}
                  className="hover:text-[#D4A574] transition-colors cursor-pointer whitespace-nowrap text-left"
                >
                  {s}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-sm uppercase tracking-widest mb-5 text-[#D4A574]">Stay Connected</h4>
          <p className="text-white/55 text-sm leading-relaxed mb-6">
            Get updates, care tips, and news from the Aligned Home Care team.
          </p>
          <div className="flex gap-3">
            {['ri-facebook-fill', 'ri-instagram-line', 'ri-linkedin-fill'].map((icon) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C0706A] hover:text-white transition-colors cursor-pointer"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/35">
        <span>&copy; {new Date().getFullYear()} Aligned Home Care. All rights reserved.</span>
        <div className="flex gap-5">
          <Link to="/policy" className="hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap">Privacy &amp; Policies</Link>
          <a href="#" rel="nofollow" className="hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}
